import { QuoteNoteType } from 'quotes/enums';

import { ItemsToCopyField } from './enums';

export const QuoteNoteTypeToCopyFieldMap = {
  [QuoteNoteType.CUSTOMER_NOTE]: ItemsToCopyField.QUOTE_CUSTOMER_NOTE,
  [QuoteNoteType.INTERNAL_NOTE]: ItemsToCopyField.QUOTE_INTERNAL_NOTE,
};
